import { create } from "zustand";

interface EventTriggerState {
  triggerCount: number;
  triggerEventFetch: () => void;
}

export const useEventTriggerStore = create<EventTriggerState>(set => ({
  triggerCount: 0,
  triggerEventFetch: () => set(state => ({ triggerCount: state.triggerCount + 1 })),
}));
